import * as Clipboard from "expo-clipboard";

import { AHText } from "arkh";
import React, { useEffect } from "react";

import { FormattedMessage } from "react-intl";
import { useAlert } from "../../common/Alert";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import { graphql, useMutation } from "react-relay";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";

import { Platform } from "react-native";
import { IntegrationWebFetcherCreateScreenWebFetcherMutation } from "./__generated__/IntegrationWebFetcherCreateScreenWebFetcherMutation.graphql";

export const IntegrationWebFetcherCreateScreen = (props: {
  navigation: StoreAdminNavigationProp<"IntegrationWebFetcherCreate">;
}) => {
  const [value, setValue] = React.useState("");

  useEffect(() => {
    let remove: undefined | (() => void);
    if (Platform.OS !== "web") {
      remove = Clipboard.addClipboardListener(async (e) => {
        setValue(
          await Clipboard.getStringAsync({
            preferredFormat: Clipboard.StringFormat.PLAIN_TEXT,
          })
        );
      }).remove;
    }
    let mounted = true;
    Clipboard.getStringAsync({
      preferredFormat: Clipboard.StringFormat.PLAIN_TEXT,
    }).then((v) => {
      if (mounted) {
        setValue(v);
      }
    });

    return () => {
      mounted = false;
      remove?.();
    };
  }, []);

  const [createWebFetcher, createWebFetcherLoading] =
    useMutation<IntegrationWebFetcherCreateScreenWebFetcherMutation>(graphql`
      mutation IntegrationWebFetcherCreateScreenWebFetcherMutation(
        $url: String!
      ) {
        store {
          createIntegrationWebFetch(url: $url) {
            id
          }
        }
      }
    `);

  const loading = createWebFetcherLoading;

  const Alert = useAlert();
  const create = () => {
    createWebFetcher({
      onError: () => {
        Alert.alert(
          "Fel Uppstod",
          "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt länk "
        );
      },
      onCompleted: (d) => {
        props.navigation.goBack();
      },
      variables: { url: value },
    });
  };

  const isUrl = value.startsWith("https://") || value.startsWith("http://");

  return (
    <IntegrationActivateScreen
      onActivate={create}
      isActivating={loading}
      isValid={!!isUrl}
      header={
        <IntegrationActivateScreen.Header
          logo={
            <AHText type="title">
              <FormattedMessage
                description="IntegrationsAdminWebFetcher create screen title"
                defaultMessage="Online Leaflet"
              />
            </AHText>
          }
        />
      }
      activation={
        <IntegrationActivateScreen.Input
          value={value}
          onChangeText={setValue}
          type="url"
          label={
            <FormattedMessage
              description="IntegrationsAdminWebFetcher create screen instruction"
              defaultMessage="Paste a link to your"
            />
          }
          placeholder={"https://"}
        />
      }
    />
  );
};
